import { Component, Optional } from '@angular/core';
import { IssueReportingService } from '../issue-reporting.service';

@Component({
  selector: 'app-acquire-token-error',
  templateUrl: './acquire-token-error.component.html',
  styleUrls: ['./acquire-token-error.component.scss']
})
export class AcquireTokenErrorComponent {
  constructor(@Optional() private issueReportingService: IssueReportingService) {}

  sendMailToL2Support() {
    this.issueReportingService.reportIssue();
  }
}
